<template>
  <div id="app">
    <transition name="move" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    document.title = this.$route.name
  },
  watch: {
    $route(val) {
      document.title = val.name;

    }
  },
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/App.vue